import React from 'react';
import { useSelector } from 'react-redux';
import { EditorActions } from 'app/stores/editor/actions';
import { getProjectState } from 'app/stores/project';
import { ProjectActions } from 'app/stores/project/actions';
import { useAppDispatch } from 'app/stores/store';
import { Button } from 'app/views/components/editor/sidebar/Button';
import { ArrowIcon, FancyArrowIcon } from 'app/views/components/Icons';
const ArrowPickerBase = (props) => {
    const { onChange } = props;
    const onSelectSimple = React.useCallback(() => {
        onChange('simple');
    }, [onChange]);
    const onSelectFancy = React.useCallback(() => {
        onChange('fancy');
    }, [onChange]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { "data-test-id": "simple", label: "Simple", Icon: ArrowIcon, onPress: onSelectSimple }),
        React.createElement(Button, { "data-test-id": "fancy", label: "Fancy", Icon: FancyArrowIcon, onPress: onSelectFancy })));
};
export const ArrowPicker = () => {
    const dispatch = useAppDispatch();
    const selection = useSelector((state) => getProjectState(state).selection);
    const setArrowType = React.useCallback((type) => {
        const patches = selection.reduce((accum, id) => {
            accum[id] = { type };
            return accum;
        }, {});
        dispatch(ProjectActions.itemsUpdate({ patches }));
    }, [selection, dispatch]);
    return React.createElement(ArrowPickerBase, { onChange: setArrowType });
};
export const ArrowDefaultsPicker = (props) => {
    const { toolId } = props;
    const dispatch = useAppDispatch();
    const onConfigChange = React.useCallback((value) => {
        dispatch(EditorActions.toolConfig({
            id: toolId,
            patch: { type: value },
        }));
    }, [toolId, dispatch]);
    return React.createElement(ArrowPickerBase, { onChange: onConfigChange });
};
